import { RootScopeEvents } from '../../../../common/services/root-scope-types';
export class TokboxStreamErrorHandler {
    constructor($rootScope, VideoProviderFactory) {
        this.$rootScope = $rootScope;
        this.VideoProviderFactory = VideoProviderFactory;
        this.onOtStreamFailed = (otStream) => {
            const stream = this.activeProvider.streams.find((s) => s.id === otStream.id);
            this.activeProvider.recreateStream(stream);
        };
        this.onStreamFailed = (stream) => {
            this.activeProvider.recreateStream(stream);
        };
    }
    get activeProvider() {
        return this.VideoProviderFactory.activeProvider;
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.OT_EXCEPTION, (_e, event) => {
            /**
             * @description In a group call(4 people of more) on bad conditions.
             * @event       cancelable: false
                            code: undefined
                            component: Subscriber {id: null, widgetId: '50bd440a-0f9f-44fc-8109-73defad51a51', session: null, stream: null, streamId: null, …}
                            error: undefined
                            message: "OT.Subscriber PeerConnection Error: Error while setting RemoteDescription InvalidStateError: Failed to execute 'setRemoteDescription' on 'RTCPeerConnection': Failed to set remote answer sdp: Called in wrong state: stable"
                            stack: "Error\n    at Function.OTErrorClass.handleJsException...
                            target: Subscriber {id: null, widgetId: '50bd440a-0f9f-44fc-8109-73defad51a51', session: null, stream: null, streamId: null, …}
                            title: undefined
                            type: "exception"
                            _defaultPrevented: false
             * @solution    resubscribe
             */
            if (event.message.includes('OT.Subscriber PeerConnection Error')) {
                const subscriber = event.target;
                this.onOtStreamFailed(subscriber.stream);
            }
        });
        this.$rootScope.$on(RootScopeEvents.STREAM.SUBSCRIPTION_ERROR, (_e, error) => {
            switch (error.event.code) {
                case 1501:
                    /**
                     * @description 40 packet loss, When you change video quality LOW HIGH LOW HIGH ...
                     * @event       cancelable: false
                                    code: 1501
                                    component: Session {on: ƒ, off: ƒ, once: ƒ, dispatchEvent: ƒ, trigger: ƒ, …}
                                    error: OTErrorClass
                                      code: 1501
                                      message: "Unable to subscribe to stream in a reasonable amount of time"
                                      name: "OT_TIMEOUT"
                                    message: "Unable to subscribe to stream in a reasonable amount of time"
                                    target: Session {on: ƒ, off: ƒ, once: ƒ, dispatchEvent: ƒ, trigger: ƒ, …}
                                    title: "Unable to Subscribe"
                                    type: "exception"
                    * @solution    resubscribe
                    */
                    this.onStreamFailed(error.stream);
            }
        });
    }
}
